import React from "react";
import { Divider } from "antd";
import './Help.scss'
import '../../scss/style.scss';
import { LinkOutlined } from "@ant-design/icons";
import { Table } from "react-bootstrap";

export default class Help extends React.Component {

    render() {
        return (
            <div className="container">
                <Divider />
                <div className="row flex-lg-row justify-content-center g-2 my-2 mx-2">
                    <h3><b>APInet Tutorial</b></h3>
                    <Divider />
                    <p className="infot">
                        Introduction
                    </p>
                    <p className="infoh">
                        This page contains information about how to use APInet, including how to make queries, how to see the results, visualize the created networks, see the annotation data for each species and for each protein, as well as how to see the expression data for each host-pathogen pair when available.
                    </p>
                    <Divider />
                    <p className="infot">
                        Selecting a host
                    </p>
                    <p className="infoh">
                        You can start by selecting the host from the Home page in the table at the bottom or by clicking the Species menu at the top of the page.
                    </p>
                    <img src={`${process.env.PUBLIC_URL}/images/help/home.png`} className="imk" alt="" />

                    <Divider />
                    <p className="infot">
                        Selecting a pathogen
                    </p>
                    <p className="infoh">
                        In this page you can change the pathogen, or also, you can change the host (1). The page will display the diseases the pathogen can cause in the selected host (2) and the pathogen taxonomy (3). You can see the annotation information of both the pathogen and the host, be it KEGG pathways, gene ontology, functional domains, subcellular localization, effector and secretory proteins (for fungi and bacteria), and transcription factors (for hosts) (4). Also, there can be a button that says <b>Check interaction expression</b> to see RNA-seq experiments between the host-pathogen pair if any exists in our database (5). Lastly, for predicting the interactions, you can click on <b>Search All Interactome</b>.
                    </p>
                    <img src={`${process.env.PUBLIC_URL}/images/help/selectpair.png`} className="imk" alt="" />

                    <Divider />
                    <p className="infot" id="experiments">
                        Viewing expression experiments
                    </p>
                    <p className="infoh">
                        If you clicked on <b>Check interaction expression</b> in the previous page, it will take you to the experiment selection page, where you will be able to change the FDR and log2 fold change and pick an experiment of your interest. Then, click <b>Get Expression Data</b>.
                    </p>
                    <img src={`${process.env.PUBLIC_URL}/images/help/selectexpression.png`} className="imk" alt="" />

                    <p className="infoh">
                        It will take you to the page with the expression data of the experiment you selected. Here you can view the raw counts data, download it, download the list of up and downregulated genes with their calculated numbers, and the file that was used to identify the expression groups for the analysis. You can also view multiple graphs that were created from the basic RNA-seq analysis, WGCNA and co-expression. 
                    </p>
                    <img src={`${process.env.PUBLIC_URL}/images/help/expression1.png`} className="imk" alt="" />
                    <img src={`${process.env.PUBLIC_URL}/images/help/expression2.png`} className="imk" alt="" />

                    <Divider />
                    <p className="infot">
                        Predicting interactions
                    </p>
                    <p className="infoh">
                        Once you click on <b>Search All Interactome</b>, it will take you to the prediction page. You can predict interactions with a <b>single</b> method, or generate a consensus between multiple methods, or concatenate the results of different methods (1). The available methods are <b>interolog</b>-based, <b>domain-based</b>, GO semantic similarity (<b>GOSemSim</b>), or <b>phylo-profiling</b> (2). After that, you can configure the databases (for interolog, domain and phylo-profiling) or the GOSemSim method, as well as their respective parameters (3). In case of interolog and domain, you can add specific host or pathogen proteins for filtering the results as a comma-separated list (4), or you can select a keyword and APInet will look it up in the selected annotation, so it will only retrieve the proteins that have that keyword in the selected annotation information. In case of GOSemSim and phylo-profiling, due to computing restrictions, you must provide a set of host and pathogen proteins. Finally, you have to click <b>Show Interactions</b> to start the prediction (5).
                    </p>
                    <img src={`${process.env.PUBLIC_URL}/images/help/interactome.png`} className="imk" alt="" />


                    <Divider />
                    <p className="infot">
                        Results visualization
                    </p>
                    <p className="infoh">
                        The results will be displayed. At the top of the page (1) will appear the selected species and the method that was used to predict the interactions. Below it (2) will appear the parameters that were used for the process. The table at the bottom will show the results in pages of, at most, 100 rows. All methods will display the Host, Expression, Pathogen and Annotation columns. The rest of the columns will depend on the selected methods. The Expression column (3) will show in how many experiments in our database does the associated gene to the corresponding host protein appears up or downregulated. If you click on <b>See experiments</b>, it will take you to the <a href="#experiments">expression</a> selection page, but it will only show the experiments where the gene is up or downregulated for FDR = 0.05 and log2 fold change = 1.5. The Annotation column will take you to a full view of the annotation data (gene ontology, KEGG, subcellular localizations, functional domains, transcription factors and virulence) for both host and pathogen proteins in the corresponding row. You can also download the full results if you click on <b>Download CSV</b> or view the interaction network clicking on <b>Vizualize network</b>.
                    </p>
                    <img src={`${process.env.PUBLIC_URL}/images/help/results.png`} className="imk" alt="" />

                    <Divider />
                    <p className="infot">
                        Network visualization
                    </p>
                    <p className="infoh">
                        In the results page you can click on <b>View network</b> to see the interaction network. Here, you can see the different proteins from both host and pathogen (host proteins are colored blue and pathogen proteins are orange). The links (or edges) between the proteins are colored according to the database that was used for predicting the interaction. To the right you can see the full list of interactions, and you can filter by them by name. Additionally, if you click on a protein, you will see the name, the degree (number of interactions) and a link to the webpage (NCBI or ENSEMBL) corresponding to that protein, and if you click on an edge, you will see the name of the link (database-host-pathogen) and links to the webpages for both proteins.
                    </p>
                    <img src={`${process.env.PUBLIC_URL}/images/help/network.png`} className="imk" alt="" />
                </div>
                <Divider />

                {/* <div className="row">
                    <p className="infot">Browser Compatibility</p>
                    <p className="infoh">APInet have been tested in the following setups.</p>

                    <Table responsive className="kbl-table table-borderless">
                        <thead className="kbl-thead">
                            <tr>
                                <th>OS</th>
                                <th>Version</th>
                                <th>Chrome</th>
                                <th>Firefox</th>
                                <th>Safari</th>
                                <th>Edge</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Linux</td>
                                <td>Ubuntu 22.04</td>
                                <td>108.0.5359.71</td>
                                <td>112.0.2</td>
                                <td>n/a</td>
                                <td>113.0.1774.35</td>
                            </tr>
                            <tr>
                                <td>MacOS</td>
                                <td>Ventura 13.3.1 (a)</td>
                                <td>108.0.5359.71</td>
                                <td>112.0.2</td>
                                <td>16.4</td>
                                <td>113.0.1774.35</td>
                            </tr>
                            <tr>
                                <td>Windows</td>
                                <td>10</td>
                                <td>108.0.5359.71</td>
                                <td>112.0.2</td>
                                <td>not tested</td>
                                <td>113.0.1774.35</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <Divider /> */}
            </div>
        )
    }
}